import * as React from 'react'

import { StudentHistoryInterface, StudentLearningSequenceInterface, } from './interfaces'

import { EXTRA_SMALL_ICON_BASE_SRC, EXTRA_EXTRA_SMALL_ICON_BASE_SRC, Tooltip, } from '../../../../Shared/index'
import {
  STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  ELL_STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  ELL_INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  ELL_ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  STARTER_DIAGNOSTIC_ACTIVITY_ID,
  INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  ELL_STARTER_DIAGNOSTIC_ACTIVITY_ID,
  ELL_INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  ELL_ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  OLD_STARTER_DIAGNOSTIC_2024_ACTIVITY_ID,
  OLD_INTERMEDIATE_DIAGNOSTIC_2024_ACTIVITY_ID,
  OLD_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID,
  OLD_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID,
  OLD_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID,
  OLD_ELL_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID,
  OLD_ELL_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID,
  OLD_ELL_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID,
} from '../../assignment_flow/assignmentFlowConstants'

export const ALL = 'All'
export const STARTER = 'starter'
export const INTERMEDIATE = 'intermediate'
export const ADVANCED = 'advanced'

export const DIAGNOSTIC_LEVELS = [STARTER, INTERMEDIATE, ADVANCED]

export const DIAGNOSTIC_INSIGHTS_USE_ELL = 'diagnosticInsightsUseELL'
export const DIAGNOSTIC_INSIGHTS_SELECTED_TIMEFRAME_VALUE = 'diagnosticInsightsSelectedTimeframeValue'

export const DIAGNOSTIC_INSIGHTS_IMG_SRC = `${window.postbuildEnv.CDN_URL}/images/pages/diagnostic_insights`

export const TROUBLE_PROCESSING_MESSAGE = 'We had trouble processing your request. Please check your network connection and try again.'

export const DEMONSTRATED_FULL_PROFICIENCY_TEXT = 'Demonstrated full proficiency in most skills'
export const RECOMMENDED_TEXT = 'Recommended'

export const NO_CLASSROOM = { id: 'no-classroom' }

export const NO_STUDENT_ID = 'no-student-id'

export const TABLE_WIDTH_PROPS = {
  maxTableWidth: 1198, // max width from design, subtracting two px for left and right table border
  minTableWidth: 963 // small enough to display full when the viewport is 1440, the default of a 13-inch Macbook Air
}

export const timeframeOptions = [
  {
    label: 'All time',
    value: 'all-time',
  },
  {
    label: 'Last school year',
    value: 'last-year',
  },
  {
    label: 'This school year',
    value: 'this-year',
  },
];

export const diagnosticTypeOptions = [
  {
    label: 'Starter Diagnostic',
    value: STARTER_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: 'Intermediate Diagnostic',
    value: INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: 'Advanced Diagnostic',
    value: ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: 'ELL Starter Diagnostic',
    value: ELL_STARTER_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: 'ELL Intermediate Diagnostic',
    value: ELL_INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: 'ELL Advanced Diagnostic',
    value: ELL_ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  },
  {
    label: '2024 | Starter Diagnostic',
    value: OLD_STARTER_DIAGNOSTIC_2024_ACTIVITY_ID,
  },
  {
    label: '2024 | Intermediate Diagnostic',
    value: OLD_INTERMEDIATE_DIAGNOSTIC_2024_ACTIVITY_ID,
  },
  {
    label: '2023 | Starter Diagnostic',
    value: OLD_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID,
  },
  {
    label: '2023 | Intermediate Diagnostic',
    value: OLD_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID,
  },
  {
    label: '2023 | Advanced Diagnostic',
    value: OLD_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID,
  },
  {
    label: '2023 | ELL Starter Diagnostic',
    value: OLD_ELL_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID,
  },
  {
    label: '2023 | ELL Intermediate Diagnostic',
    value: OLD_ELL_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID,
  },
  {
    label: '2023 | ELL Advanced Diagnostic',
    value: OLD_ELL_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID,
  }
]

export const DemonstratedProficiencyFlag = () => {
  return (
    <Tooltip
      isTabbable={false}
      tooltipText={DEMONSTRATED_FULL_PROFICIENCY_TEXT}
      tooltipTriggerText={<div className="proficiency-flag">
        <img alt={DEMONSTRATED_FULL_PROFICIENCY_TEXT} src={`${EXTRA_SMALL_ICON_BASE_SRC}/check-circle.svg`} />
      </div>}
    />
  )
}

export const RecommendedFlag = () => {
  return (
    <div className="recommended-flag">
      <img alt="" src={`${EXTRA_EXTRA_SMALL_ICON_BASE_SRC}/star-filled.svg`} />
      <span>{RECOMMENDED_TEXT}</span>
    </div>
  )
}

export const helpImg = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/help.svg`} />

export const accountImg = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/account-green.svg`} />

export const GRAY_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG = <img alt="" className="background-img" src={`${DIAGNOSTIC_INSIGHTS_IMG_SRC}/grey-student-history-pre-diagnostic-section.svg`} />
export const GREEN_STUDENT_HISTORY_PRE_DIAGNOSTIC_BACKGROUND_IMG = <img alt="" className="background-img" src={`${DIAGNOSTIC_INSIGHTS_IMG_SRC}/green-student-history-pre-diagnostic-section.svg`} />
export const GRAY_STUDENT_HISTORY_BACKGROUND_IMG = <img alt="" className="background-img" src={`${DIAGNOSTIC_INSIGHTS_IMG_SRC}/grey-student-history-section.svg`} />
export const GREEN_STUDENT_HISTORY_BACKGROUND_IMG = <img alt="" className="background-img" src={`${DIAGNOSTIC_INSIGHTS_IMG_SRC}/green-student-history-section.svg`} />

// for all date functions, passing undefined as first argument to default to user's browser settings, same behavior as moment

export function formatDateToMMDDYY(date) {
  return new Date(date).toLocaleDateString(undefined, { year: "2-digit", month: "2-digit", day: "2-digit" });
}

export function formatDateToMMDDYYYY(date) {
  return new Date(date).toLocaleDateString(undefined, { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function formatDateToShortFormat(date) {
  return new Date(date).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export function diagnosticLevelToUnitTemplateId(ell) {
  if (ell) {
    return {
      [STARTER]: ELL_STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
      [INTERMEDIATE]: ELL_INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
      [ADVANCED]: ELL_ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID
    }
  }

  return {
    [STARTER]: STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
    [INTERMEDIATE]: INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
    [ADVANCED]: ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID
  }
}

export function diagnosticLevelToActivityId(ell) {
  if (ell) {
    return {
      [STARTER]: ELL_STARTER_DIAGNOSTIC_ACTIVITY_ID,
      [INTERMEDIATE]: ELL_INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
      [ADVANCED]: ELL_ADVANCED_DIAGNOSTIC_ACTIVITY_ID
    }
  }

  return {
    [STARTER]: STARTER_DIAGNOSTIC_ACTIVITY_ID,
    [INTERMEDIATE]: INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
    [ADVANCED]: ADVANCED_DIAGNOSTIC_ACTIVITY_ID
  }
}

export function proficientDiagnostic(studentLearningSequences: StudentLearningSequenceInterface[]) {
  for (const studentLearningSequence of studentLearningSequences || []) {
    const { student_learning_sequence_activities } = studentLearningSequence;
    const { pre_diagnostic, post_diagnostic } = student_learning_sequence_activities;

    const proficientActivity =
      pre_diagnostic?.find((preDiagnosticActivity) => preDiagnosticActivity.proficient) ||
      post_diagnostic?.find((postDiagnosticActivity) => postDiagnosticActivity.proficient);

    if (proficientActivity) {
      return proficientActivity;
    }
  }

  return null; // Return null if no proficient activity is found
}

export function generateRecommendations(ell: Boolean, studentHistories: StudentHistoryInterface[], classroomId: number) {
  const diagnosticLevelToUnitTemplateIdHash = diagnosticLevelToUnitTemplateId(ell)

  const studentIdsForStarter = []
  const studentIdsForIntermediate = []
  const studentIdsForAdvanced = []

  studentHistories.forEach(studentHistory => {
    const { user_id, student_learning_sequences, } = studentHistory
    const { starter, intermediate, advanced, } = student_learning_sequences

    if (!proficientDiagnostic(starter)) {
      studentIdsForStarter.push(user_id)
      return
    }

    if (!proficientDiagnostic(intermediate)) {
      studentIdsForIntermediate.push(user_id)
      return
    }

    if (!proficientDiagnostic(advanced)) {
      studentIdsForAdvanced.push(user_id)
    }
  })

  return {
    [STARTER]: {
      unit_template_id: diagnosticLevelToUnitTemplateIdHash[STARTER],
      student_ids: studentIdsForStarter
    },
    [INTERMEDIATE]: {
      unit_template_id: diagnosticLevelToUnitTemplateIdHash[INTERMEDIATE],
      student_ids: studentIdsForIntermediate
    },
    [ADVANCED]: {
      unit_template_id: diagnosticLevelToUnitTemplateIdHash[ADVANCED],
      student_ids: studentIdsForAdvanced
    }
  }
}

export function studentHistoryHasPreDiagnostic(studentHistory) {
  if (Object.keys(studentHistory.student_learning_sequences).length === 0) { return false }
  const learningSequencesWithPreDiagnostic = Object.values(studentHistory.student_learning_sequences).find(studentLearningSequenceArray => {
    return studentLearningSequenceArray.find(sls => {
      const { student_learning_sequence_activities, } = sls
      return student_learning_sequence_activities.pre_diagnostic
    })
  })
  return learningSequencesWithPreDiagnostic
}
